import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import SeasonalNote from "@/components/SeasonalNote";
import Marquee from "@/components/Marquee";
import About from "@/components/About";
import Flavours from "@/components/Flavours";
import Desserts from "@/components/Desserts";
import Menu from "@/components/Menu";
import Experience from "@/components/Experience";
import DogFriendly from "@/components/DogFriendly";
import Reviews from "@/components/Reviews";
import Gallery from "@/components/Gallery";
import Visit from "@/components/Visit";
import Footer from "@/components/Footer";
import Shop from "@/pages/Shop";
import Story from "@/pages/Story";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Loyalty from "@/pages/Loyalty";
import Staff from "@/pages/Staff";
import ResetPassword from "@/pages/ResetPassword";
import Privacy from "@/pages/Privacy";
import CartHire from "@/pages/CartHire";
import CookieConsent from "@/components/CookieConsent";

const Home = () => (
  <main>
    <Hero />
    <SeasonalNote />
    <Marquee />
    <About />
    <Flavours />
    <Desserts />
    <Menu />
    <Experience />
    <DogFriendly />
    <Reviews />
    <Gallery />
    <Visit />
  </main>
);

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.08, anchors: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <BrowserRouter>
      <div className="App bg-cream text-teal font-body">
        <div className="grain-overlay" aria-hidden="true" />
        <Toaster position="bottom-center" toastOptions={{ style: { background: "#5B2A86", color: "#FFF8EE", border: "1px solid #C5A059" } }} />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/story" element={<Story />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/loyalty" element={<Loyalty />} />
          <Route path="/staff" element={<Staff />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/cart-hire" element={<CartHire />} />
        </Routes>
        <CookieConsent />
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
